export function getActiveMunicipalityId(): string | null {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem('activeMunicipalityId');
  return value && value.trim() ? value : null;
}

export function setActiveMunicipalityId(id: string | null): void {
  if (typeof window === 'undefined') return;
  if (!id) {
    window.localStorage.removeItem('activeMunicipalityId');
    return;
  }
  window.localStorage.setItem('activeMunicipalityId', id);
}

export function getResolvedActiveMunicipalityId(
  municipalities: Array<{ id: string }> | null | undefined,
  current = getActiveMunicipalityId()
): string | null {
  if (municipalities == null || municipalities.length === 0) {
    return current;
  }

  const existing = current ? municipalities.find((m) => m.id === current) : null;
  return existing?.id ?? municipalities[0].id;
}

export function resolveActiveMunicipalityId(municipalities: Array<{ id: string }> | null | undefined): string | null {
  const current = getActiveMunicipalityId();
  const resolvedId = getResolvedActiveMunicipalityId(municipalities, current);
  if (resolvedId !== current) {
    setActiveMunicipalityId(resolvedId);
  }
  return resolvedId;
}
